/* eslint-disable */
import sysConfig from '@/configs/sys';
import validator from '@/lib/json-validator';

const matlsApiUrl = sysConfig.matlsApiUrl;

validator
  .addSchema('/fudao/fudaos', {
    type: 'object',
    properties: {
      startTime_after: {type: 'string'},
      startTime_before: {type: 'string'},
      teacherId: {type: 'string'},
      studentId: {type: 'string'}
    }
  })
  .addSchema('/fudao/teacherForm', {
    type: 'object',
    properties: {
      fudaoId: {type: 'string'},
      teacherId: {type: 'string'},
      teacherForm: {
        type: 'object',
        properties: {
          fudaoType: {type: 'string'},
          suggestion: {type: 'string'},
          fudaoSubjects: {type: 'array'},
          knowledgePoints: {type: 'array'},
          ratingBeforeFudao: {type: 'number'},
          ratingAfterFudao: {type: 'number'}
        },
        required: [
          'fudaoType', 'suggestion', 'fudaoSubjects',
          'knowledgePoints', 'ratingBeforeFudao', 'ratingAfterFudao'
        ]
      }
    },
    required: ['fudaoId', 'teacherId', 'teacherForm']
  })
  .addSchema('/fudao/studentForm', {
    type: 'object',
    properties: {
      fudaoId: {type: 'string'},
      studentId: {type: 'string'},
      studentForm: {
        type: 'object',
        properties: {
          rating: {type: 'number'}
        },
        required: ['rating']
      }
    },
    required: ['fudaoId', 'studentId', 'studentForm']
  });



export default {
  getFudaos(params) {
    validator.validate('/fudao/fudaos', params);

    return fetch
      .get(`${matlsApiUrl}/fudaos`, {params})
      .then(res => res.json());
  },

  reportTeacherForm(params) {
    validator.validate('/fudao/teacherForm', params);

    let fudaoId = encodeURIComponent(params.fudaoId);
    return fetch
      .patch(`${matlsApiUrl}/fudaos/${fudaoId}/teacherForm`, {params});
  },

  reportStudentForm(params) {
    validator.validate('/fudao/studentForm', params);

    let fudaoId = encodeURIComponent(params.fudaoId);
    return fetch
      .patch(`${matlsApiUrl}/fudaos/${fudaoId}/studentForm`, {params});
  }
};